module.exports = __webpack_public_path__ + "frontend/images/gold/carousel/live/live@2.png?8ffe8aabdb8b23676535da7a5402f911";